// extracted by mini-css-extract-plugin
export default {"mention":"LastMessageText_mention__SCC8A"};